import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { useTranslation } from "react-i18next";

const TitleContext = createContext();

/** Keys look like `sidenav.home` / `labels.view` — anything else is treated as a ready label. */
const looksLikeI18nKey = (value) =>
  typeof value === "string" && /^[a-z0-9_.]+$/i.test(value.trim());

export const TitleProvider = ({ children }) => {
  const { t } = useTranslation("global");
  const [titleInput, setTitleInput] = useState("sidenav.home");

  const setTitle = useCallback((value) => {
    setTitleInput(value == null ? "sidenav.home" : value);
  }, []);

  // Derive title — no useEffect/setState feedback loop with unstable `t`.
  const title = useMemo(() => {
    if (titleInput == null || titleInput === "") return "";
    if (looksLikeI18nKey(titleInput)) {
      return t(titleInput);
    }
    return String(titleInput);
  }, [titleInput, t]);

  const value = useMemo(() => ({ title, setTitle }), [title, setTitle]);

  return (
    <TitleContext.Provider value={value}>{children}</TitleContext.Provider>
  );
};

export const useTitle = () => useContext(TitleContext);
